import { CreateEditFormDrawer } from 'framework/ViewTypes/contentLayout';
import { useRecruitmentPoolUrl } from '../../routing';
import type { RecruitmentPool, RecruitmentPoolFormValues } from '../../types';
import useRecruitmentPoolService from '../../useRecruitmentPoolService';
import { getRecruitmentPoolSections } from './editRecruitmentPoolSections';
import editRecruitmentPoolValidation from './editRecruitmentPoolValidation';

type RecruitmentPoolFormDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  recruitmentPool?: RecruitmentPool;
  onSuccess?: (pool: RecruitmentPool) => void;
  isEdit?: boolean;
};

const createInitialValues = (): RecruitmentPoolFormValues => ({
  name: '',
  description: '',
  requiredCandidateCheckTypes: [],
  recruitingTeam: [],
});

const RecruitmentPoolFormDrawer = ({
  isOpen,
  onClose,
  recruitmentPool,
  onSuccess,
  isEdit = false,
}: RecruitmentPoolFormDrawerProps) => {
  const { create, update } = useRecruitmentPoolService();
  const { getSingleEntityUrl } = useRecruitmentPoolUrl();

  return (
    <CreateEditFormDrawer
      key={`${recruitmentPool?.id ?? 'create'}-${isOpen}`}
      isOpen={isOpen}
      onClose={onClose}
      title={isEdit ? 'Edit recruitment pool' : 'Create recruitment pool'}
      initialData={recruitmentPool ?? createInitialValues()}
      isCreateRequest={!isEdit}
      submitFormFunc={values =>
        recruitmentPool
          ? update(recruitmentPool.id, values as RecruitmentPoolFormValues)
          : create(values as RecruitmentPoolFormValues)
      }
      getValidationSchemaFunc={() => Promise.resolve(editRecruitmentPoolValidation)}
      getSections={getRecruitmentPoolSections}
      afterSubmit={
        recruitmentPool
          ? {
              execute: updatedPool => {
                onSuccess?.(updatedPool);
                onClose();
              },
              message: 'Recruitment pool updated successfully.',
            }
          : {
              redirect: createdPool => getSingleEntityUrl(createdPool.id),
              message: 'Recruitment pool created successfully.',
            }
      }
    />
  );
};

export default RecruitmentPoolFormDrawer;
